import React, {Component} from 'react'

import {Map, Marker, TileLayer, ZoomControl} from 'react-leaflet';
import {divIcon} from 'leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import TagManager from './../utils/tagManager';
import { AntPath, antPath } from 'leaflet-ant-path';

const disableClusteringAtZoom = '6' // String required
const zoomDelta = 0.75

class DestinationsMap extends Component {
    constructor(props) {
        super(props)
        this.state = {
            map: null,
            clusters: [],
            panel: false,
            currentPanel: null,
            clustered: false,
            viewport: {
                center: [48.5, 8],
                zoom: 1
            },
            buttonWording: '',
            tablet: (window.innerWidth <= 1024),
        }
        this.antPolyline = null
        this.mounted = false
    }

    componentDidMount() {
        this.mounted = true
        let closePanel = this.props.proxy.querySelector(".right-panel .close-panel")
        closePanel.addEventListener("click", (e) => {
            this.closePanel()
        }, false)

        this.setState({
            viewport: {
                center: this.props.center,
                zoom: this.state.tablet ? 3.5 : 4.25 // parseInt(this.props.zoom)
            },
            clusters: this.props.clusters.map((cluster) => {
                cluster.markers.map((marker) => {
                    if (marker.position[1] <= -100) {
                        marker.position[1] += 360;
                        marker.lng += 360;
                    }
                    return marker;
                })
                return cluster;
            })
        })

        window.map = this.map;

        setTimeout(() => {
            if(this.mounted && !this.state.clustered && this.state.clusters[0]) {
                this.clusterClicked(this.state.clusters[0])
            }
        }, 1500)


       this.map.fitBounds(new L.LatLngBounds(new L.LatLng(-60, -170), new L.LatLng(85, 179)))
    }

    componentDidUpdate() {
        Array.from(document.querySelectorAll('.leaflet-control-attribution a')).forEach((el) => {
            el.setAttribute('target', '_blank')
        })
    }

    componentWillUnmount() {
        this.mounted = false
    }

    createAntPathOnMap(e) {
        this.removeAntPathOnMap()
        // Constructor
        this.antPolyline = new AntPath(e.target.options.position.position, {
            color: 'transparent',
            weight: 4,
            dashArray: [8, 12],
            delay: 400,
            pulseColor: 'white',
            paused: false,
            interactive: false,
            lineCap: 'round'
        })
        this.antPolyline.addTo(this.map)
    }

    removeAntPathOnMap() {
        if (this.antPolyline) {
            this.antPolyline.removeFrom(this.map)
        }
    }

    onMarkerClick(e) {
        this.setPanel(e.target.options.position)
        if (e.target.options.position.position.length <= 1) {
            this.removeAntPathOnMap()
        }
        else {
            this.createAntPathOnMap(e)
        }
    }

    onMarkerMouseover(e) {
        if (e.target.options.position.position.length <= 1) {
            return
        }
        this.createAntPathOnMap(e)
    }

    onMarkerMouseout(e) {
        if (e.target.options.position.position.length <= 1) {
            return
        }
        const {currentPanel, panel} = this.state
        if (!panel || (panel && currentPanel !== e.target.options.position.slug)) {
            this.removeAntPathOnMap()
        }
    }

    setPanel(marker) {
        if (marker !== 'undefined') {

            TagManager.pushEvent('clic-carte', 'carte', 'zoom', marker.title);

            if (!this.state.panel) {
                this.props.proxy.querySelector('.right-panel').classList.add("open");
                this.setState({
                    panel: true,
                })
            }
            this.props.proxy.querySelector('.right-panel').className = "right-panel open " + marker.theme;
            this.props.proxy.querySelector('.right-panel .cta .inline-button button').className = "inline-button__cta color-color-white background-primary-color";
            this.props.proxy.querySelector('.right-panel .texts .title').innerHTML = marker.title;
            this.props.proxy.querySelector('.right-panel .texts .title').className = "title";
            this.props.proxy.querySelector('.right-panel .texts .description .inline-text').innerHTML = marker.description;
            this.props.proxy.querySelector('.right-panel .texts .cta .link').setAttribute('href', marker.link);
            this.props.proxy.querySelector('.right-panel .texts .cta .link').addEventListener('click', (event) => {
                TagManager.pushEvent('clic-carte', 'carte', 'clic', this.props.proxy.querySelector('.right-panel .texts .title').innerHTML);
            });
            this.props.proxy.querySelector('.right-panel .header-image .content').innerHTML = `<img src="${marker.img}" alt="${marker.title}" loading="lazy"/>`;

            this.setState({
                currentPanel: marker.slug
            })
        }
    }

    closePanel() {
        this.props.proxy.querySelector('.right-panel').className = this.props.proxy.querySelector('.right-panel').className.replace("open", "");
        this.setState({
            panel: false,
            currentPanel: null,
        }, () => {
            this.removeAntPathOnMap()
        })
    }

    clusterClicked(cluster, key, a) {

        this.setState({
            clustered: true,
            buttonWording: cluster.button
        })

        let markers = cluster.markers;
        let pos = markers
            .filter((marker) => {
                return marker.lat !== 46.8852;
            })
            .map((marker) => {
                return marker.position
            });

        if(a) {
            // a.zoomToBounds();
        }

        let bounds = L.latLngBounds(pos)

        this.map.flyToBounds(bounds, {
            padding: [70, 70],
            animate: true,
            easeLinearity: 0.6,
            duration: 1.3,
        })
    }

    get map() {
        return this.refs.map.leafletElement
    }

    closeCluster() {
        this.setState({
            clustered: false,
            viewport: {
                center: this.props.center,
                zoom: this.state.tablet ? 3.5 : 4.25 // parseInt(this.props.zoom)
            }
        })

        if (this.state.panel) {
            this.closePanel()
        }

        setTimeout(() => {
            Array.from(document.querySelectorAll('.leaflet-marker-icon .marker-cluster')).forEach((el) => {
                el.parentNode.style.opacity = 1;
            })
        }, 500)
    }

    onViewportChanged(viewport) {
        this.setState({viewport});
    }

    getMapZoom() {
        let currentZoomLevel = this.map && this.map.getZoom()
        let clustered
        if (currentZoomLevel >= parseInt(disableClusteringAtZoom) - zoomDelta) {
            clustered = true
        }
        else {
            clustered = false
        }
        this.setState({clustered})
    }

    render() {
        const createMarker = (marker, key) => {
            return (
                <div key={key}>
                    <Marker
                        icon={divIcon({
                            html: '<div class="marker-icon">' +
                                ' <div class="background"></div>' +
                                ' <div class="center"></div>' +
                                ' <div class="label">' + marker.title + '</div>' +
                                ' <div class="over">' +
                                '   <div class="flare f-anim1"></div>' +
                                '   <div class="flare f-anim2"></div>' +
                                '   <div class="flare f-anim3"></div>' +
                                ' </div>' +
                                '</div>'
                        })}
                        position={marker}
                        onClick={(marker) => this.onMarkerClick(marker)}
                        onMouseover={(marker) => this.onMarkerMouseover(marker)}
                        onMouseout={(marker) => this.onMarkerMouseout(marker)}
                    />
                </div>
            )
        }

        const createClusterCustomIcon = function (cluster) {
            return L.divIcon({
                html:   '<div class="marker-cluster">' +
                        ' <span class="number">' + cluster.getChildCount() + '</span>' +
                        ' <div class="background"></div>' +
                        ' <div class="over">' +
                        '   <div class="flare f-anim1"></div>' +
                        '   <div class="flare f-anim2"></div>' +
                        '   <div class="flare f-anim3"></div>' +
                        ' </div>' +
                        '</div>',
                className: 'marker-cluster-custom',
            });
        }

        const ClusterGroup = this.state.clusters.map((cluster, key) => {
            if (cluster.markers.length > 1) {
                return (
                    <MarkerClusterGroup ref={'cluster_' + key}
                                        onClusterClick={(a) => this.clusterClicked(cluster, key, a)}
                                        key={key}
                                        iconCreateFunction={createClusterCustomIcon}
                                        showCoverageOnHover={false}
                                        zoomToBoundsOnClick={false}
                                        disableClusteringAtZoom={disableClusteringAtZoom}
                                        spiderfyOnMaxZoom={false}
                                        maxClusterRadius={130}
                                        removeOutsideVisibleBounds={true}
                    >
                        {cluster.markers.map(createMarker)}
                    </MarkerClusterGroup>
                )
            }
        })

        const SingleMarkers = this.state.clusters.map((cluster, key) => {
            if (cluster.markers.length === 1) {
                let marker = cluster.markers[0]
                return createMarker(marker, key)
            }
        })

        const MapUrl = 'https://data.geopf.fr/wmts?service=WMTS&request=GetTile&version=1.0.0&tilematrixset=PM&tilematrix={z}&tilecol={x}&tilerow={y}&layer=ORTHOIMAGERY.ORTHOPHOTOS&format=image/jpeg&style=normal'

        const LeafletMap = (
            <Map ref="map"
                 zoomControl={false}
                 doubleClickZoom={false}
                 dragging={true}
                 style={{"height": "100%", "width": "100%"}}
                 scrollWheelZoom={false}
                 viewport={this.state.viewport}
                 maxZoom={10}
                 boundsOptions={{padding: [5, 5]}}
                 minZoom={this.state.tablet ? 1.2 : 2}
                 zoomSnap={0}
                 zoomDelta={zoomDelta}
                 onZoom={this.getMapZoom.bind(this)}
                 onViewportChanged={this.onViewportChanged.bind(this)}
            >
                {SingleMarkers}
                <TileLayer
                    attribution={`<a href="http://www.ign.fr/" target="_blank" onclick="dataLayer.push({
                      event: 'clic-IGN-logo',
                      eventLabel: 'http://www.ign.fr',
                      eventAction: 'Logo_IGN',
                      eventCategory: 'Navigation'
                    })"><img src="/data/images/map/ign-logo.png" loading="lazy" width="40px" height="20px" /></a>`}
                    url={MapUrl}
                />
                {ClusterGroup}
                <ZoomControl position="bottomleft"/>
            </Map>
        );

        return (
            <div className="leaflet-map-container">
                {LeafletMap}
                {
                    this.state.clustered && this.state.buttonWording &&  (
                        <div className="close-cluster" onClick={() => this.closeCluster()}>
                            <i className="icon-back-arrow"/> <span>{this.state.buttonWording}</span>
                        </div>
                    )
                }
            </div>
        )
    }
}

export default (DestinationsMap)


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/components/DestinationsMap.js